import { render, staticRenderFns } from "./RoomFour.vue?vue&type=template&id=4e267906&scoped=true&"
import script from "./RoomFour.vue?vue&type=script&lang=js&"
export * from "./RoomFour.vue?vue&type=script&lang=js&"
import style0 from "./RoomFour.vue?vue&type=style&index=0&id=4e267906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e267906",
  null
  
)

export default component.exports